import { render, staticRenderFns } from "./PrecoDeCusto.vue?vue&type=template&id=1825ab7b&scoped=true"
import script from "./PrecoDeCusto.vue?vue&type=script&lang=js"
export * from "./PrecoDeCusto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1825ab7b",
  null
  
)

export default component.exports